import axios from 'axios'
import config from './config'
export default {
  login (request = {}) {
    return axios.post(config.serverURI + '/authweb', request)
          .then((response) => Promise.resolve(response))
          .catch((error) => Promise.reject(error))
  },
  getUserList (request = {}) {
    const ldata = localStorage.getItem('users')
    if ( ldata == null ) return []
    const data = JSON.parse( ldata )
    const token = data.token
    console.log('VVVVTOEKVVVV--->' + token)
    console.log(token)
    return axios.get(config.serverURI + '/users', {
        dataType: 'json',
        params:request,
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + token
        }
      })
      .then((response) => Promise.resolve(response))
      .catch((error) => Promise.reject(error))
  },
  getForwardUserList(request = {}){
    const ldata = localStorage.getItem('users')
    if ( ldata == null ) return []
    const data = JSON.parse( ldata )
    const token = data.token
    console.log('VVVVTOEKVVVV--->' + token)
    console.log(token)
    return axios.get(config.serverURI + '/users/nearme', {
        dataType: 'json',
        params:request,
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + token
        }
      })
      .then((response) => Promise.resolve(response))
      .catch((error) => Promise.reject(error))
  },
  getUserDetails (userId = '') {
    const ldata = localStorage.getItem('users')
    if ( ldata == null ) return []
    const data = JSON.parse( ldata )
    const token = data.token
    console.log('VVVVTOEKVVVV--->' + token)
    console.log(token)
    return axios.get(config.serverURI + '/users/' + userId, {
        dataType: 'json',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + token
        }
      })
      .then((response) => Promise.resolve(response))
      .catch((error) => Promise.reject(error))
  },
  addUser (request = {}) {
    const ldata = localStorage.getItem('users')
    if ( ldata == null ) return []
    const data = JSON.parse( ldata )
    const token = data.token
    console.log('VVVVTOEKVVVV--->' + token)
    console.log(token)
    
   var headers = {
    'Content-Type': 'application/json',
    'Authorization': 'Bearer ' + token
}
    return axios.post(config.serverURI + '/users/webAdd', request , {"headers" : headers} )
      .then((response) => Promise.resolve(response))
      .catch((error) => Promise.reject(error))
  },
  updateUser (request = {}) {
    const ldata = localStorage.getItem('users')
    if ( ldata == null ) return []
    const data = JSON.parse( ldata )
    const token = data.token
    const id = request._id
    delete request._id
    var headers = {
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + token
    }
    return axios.patch(config.serverURI + '/users/' + id, request , {"headers" : headers} )
      .then((response) => Promise.resolve(response))
      .catch((error) => Promise.reject(error))
  },
  uploadProflePhoto (formdata,file) {
    const ldata = localStorage.getItem('users')
    if ( ldata == null ) return []
    const data = JSON.parse( ldata )
    const token = data.token
    console.log('VVVVTOEKVVVV--->' + token)
    console.log(token)
    
   var headers = {
    'Content-Type': 'multipart/form-data',
    'Authorization': 'Bearer ' + token
}
    return axios.post(config.serverURI + '/files', formdata , {"headers" : headers} )
      .then((response) => Promise.resolve(response))
      .catch((error) => Promise.reject(error))
  },
}


// WEBPACK FOOTER //
// ./src/vuex/api/services/user.js